<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">{{ this.project.employerProjectNumber }}</p>
      <h2 class="presentation-page__title">
        Projektübersicht — {{ this.project.employerProjectNumber }}
      </h2>
      <p class="presentation-page__text">
        Schlüsselfertige PV-Dachanlage. Vertraglich gesichert, baureif, ohne Genehmigungsbedarf.
      </p>
      <div class="presentation-page__metric-cards">
        <article
          v-for="metric in metrics"
          :key="metric.label"
          :class="[
            'presentation-page__metric-card',
            `presentation-page__metric-card--${metric.accent}`,
          ]"
        >
          <p class="presentation-page__metric-label">{{ metric.label }}</p>
          <p class="presentation-page__metric-value">{{ metric.value }}</p>
        </article>
      </div>
      <p class="presentation-page__caption">
        Bereit zur Installation — IAB-fähig — mit gesicherten Rechten und Netzanschluss
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';
import { formatNumber, NUMBER_FORMAT } from '@/helpers/numberFormat';

export default {
  name: 'MasterPresentationPrintPage33',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {
    overallInstallationPower() {
      return formatNumber(
        this.project?.solarPlant?.solarPlantOverallPower,
        NUMBER_FORMAT.DECIMAL_TRIPLE
      );
    },

    totalInvestment() {
      return formatNumber(this.project?.effectiveSettlementValue, NUMBER_FORMAT.CURRENCY);
    },

    metrics() {
      return [
        {
          accent: 'brand-primary',
          label: 'Gesamtinstallationsleistung',
          value: `${this.overallInstallationPower} kWp`,
        },
        { accent: 'brand-secondary', label: 'Vertragslaufzeit', value: '20 + 2 × 5 Jahre' },
        { accent: 'brand-teal', label: 'Gestattungsvertrag', value: 'Liegt vor' },
        { accent: 'brand-teal', label: 'Netzzusage', value: 'Vorhanden' },
        { accent: 'brand-secondary', label: 'Baugenehmigungen', value: 'Nicht erforderlich' },
        { accent: 'brand-primary', label: 'Gesamtinvestition', value: `${this.totalInvestment}` },
      ];
    },
  },
};
</script>
